import { render, staticRenderFns } from "./navigation-top.vue?vue&type=template&id=37a116e2&scoped=true&"
import script from "./navigation-top.vue?vue&type=script&lang=js&"
export * from "./navigation-top.vue?vue&type=script&lang=js&"
import style0 from "./navigation-top.vue?vue&type=style&index=0&id=37a116e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a116e2",
  null
  
)

export default component.exports